import debounce from '../modules/debounce'
function initSplitBackground(component) {
  const firstChild = component.querySelector('.split-background__child')
  const firstChildImage = component.querySelector('.split-background__image')
  if (!firstChild || !firstChildImage) return
  const cardsBackground = component.querySelector('.background--main')
  function setCardsBackgroundHeight() {
    //Set height of cards background to midpoint of first card image
    const cardDistanceFromTop =
      firstChild.getBoundingClientRect().top -
      component.getBoundingClientRect().top
    const cardImageOffset = firstChildImage.getBoundingClientRect().height / 2
    const cardsBackgroundHeight = cardDistanceFromTop + cardImageOffset
    //Set background height
    cardsBackground.style.height = cardsBackgroundHeight + 'px'
  }
  window.addEventListener('resize', debounce(setCardsBackgroundHeight, 100))
  setCardsBackgroundHeight()
}
const splitBackgroundComponentList =
  document.querySelectorAll('.split-background')
splitBackgroundComponentList.length &&
  splitBackgroundComponentList.forEach(initSplitBackground)
